import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import './not-found.css';

const NotFound = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="not-found-container">
      <Helmet>
        <title>404 - Page non trouvée</title>
      </Helmet>
      <h1>404</h1>
      <p>Oups… la page que vous cherchez n’existe pas.</p>
      <a href="/" className="btn-home">Retour à l’accueil</a>
    </div>
  );
};

export default NotFound;
